import logo from './logo.svg';
import './App.css';
import csvData from './data/data-final-v3.csv';
import { useEffect, useState } from 'react';
import Papa from 'papaparse';

// const data = Papa.parse(csvData, {header: true});

function App() {

  const [level, setLevel] = useState('all');
  const [gender, setGender] = useState('all');
  const [age, setAge] = useState('all');
  const [state, setState] = useState('all');
  const [data, setData] = useState([]);

  useEffect(() => {
    Papa.parse(csvData, {
      download: true,
      header: true,
      complete: results => { "SETTING DATA"; setData(results.data) }
    });
  }, []);

  const levels = ['2.5', '3.0', '3.5', '4.0', '4.5'];
  const genders = ['F', 'M'];
  const ages = ['01-17', '18-34', '35-49', '50-59', '60-69', '70+'];
  const states = [
    'Alabama',
    'Florida',
    'Georgia',
    'Kentucky',
    'Mississippi',
    'North Carolina',
    'South Carolina',
    'Tennessee'
  ];

  // console.log(csvData);
  // console.log(data);

  function reset() {
    setLevel('all');
    setGender('all');
    setAge('all');
    setState('all');
  }

  // const states = [...new Set(data.map(row => row.State))].filter(state => !['California', 'Michigan', 'Texas', 'Virginia', 'West Virginia', 'Wisconsin'].includes(state));
  const filteredData = structuredClone(data.filter(person =>
    (level == 'all' || person["Skill Level"] == level) &&
    (gender == 'all' || person["Gender"] == gender) &&
    (age == 'all' || person["Age Bucket"] == age) &&
    (state == 'all' || person["State"] == state)
  ));
  const pivotData = filteredData.reduce((prev, curr) => {
    const name = curr["Full Name"]?.toLowerCase();
    if (name == 'john waters') {
      if (prev[name]) {
        console.log("OLD", prev[name]["Medal Value"]);
      }

      console.log(curr["Medal Value"]);
      console.log(curr["MEDAL Earned"]);
    }
    if (prev.hasOwnProperty(name)) {
      prev[name]["Medal Value"] += parseInt(curr["Medal Value"]);
      switch (curr["MEDAL Earned"]) {
        case "GOLD":
          prev[name]["Gold Value"] += parseInt(curr["Medal Value"]);
          break;
        case "SILVER":
          prev[name]["Silver Value"] += parseInt(curr["Medal Value"]);
          break;
        case "BRONZE":
          prev[name]["Bronze Value"] += parseInt(curr["Medal Value"]);
          break;
      }
    }
    else {
      prev[name] = curr;
      prev[name]["Medal Value"] = parseInt(prev[name]["Medal Value"]);
      prev[name]["Gold Value"] = 0;
      prev[name]["Silver Value"] = 0;
      prev[name]["Bronze Value"] = 0;
      switch (curr["MEDAL Earned"]) {
        case "GOLD":
          prev[name]["Gold Value"] += parseInt(curr["Medal Value"]);
          break;
        case "SILVER":
          prev[name]["Silver Value"] += parseInt(curr["Medal Value"]);
          break;
        case "BRONZE":
          prev[name]["Bronze Value"] += parseInt(curr["Medal Value"]);
          break;
      }
    }
    return prev;
  }, {});
  const rowData = Object.values(pivotData);
  rowData.sort((a, b) => b["Medal Value"] - a["Medal Value"]);
  let rank = 0;
  let previousValue = 0;
  let ties = 1;
  const rows = rowData.map((row, idx) => {
    if (row["Medal Value"] == previousValue) {
      ties++;
    }
    else {
      rank += ties;
      ties = 1;
      previousValue = row["Medal Value"];
    }
    return (
      <tr key={idx}>
        <td>{rank}</td>
        <td>{row["Full Name"]}</td>
        <td>{row["Gold Value"]}</td>
        <td>{row["Silver Value"]}</td>
        <td>{row["Bronze Value"]}</td>
        <td>{row["Medal Value"]}</td>
      </tr>
    )
  });

  return (
    <div className="App p-3" style={{ width: '800px', maxWidth: '100%' }}>
      <div class="filters row  gy-2 mb-4 justify-content-center align-items-end">
        <div class="filter col-sm-auto">
          <label for="levelSelect" className="form-label"><strong>Skill</strong></label>
          <select name="" id="levelSelect" className="form-select" onChange={(e) => setLevel(e.target.value)} value={level}>
            <option value="all">All</option>
            <option value="2.5">2.5</option>
            <option value="3.0">3.0</option>
            <option value="3.5">3.5</option>
            <option value="4.0">4.0</option>
            <option value="4.5">4.5</option>
          </select>
        </div>
        <div class="filter col-sm-auto">
          <label for="genderSelect" className="form-label"><strong>Gender</strong></label>
          <select name="" id="genderSelect" className="form-select" onChange={(e) => setGender(e.target.value)} value={gender}>
            <option value="all">All</option>
            <option value="F">Female</option>
            <option value="M">Male</option>
          </select>
        </div>
        <div class="filter col-sm-auto">
          <label for="ageSelect" className="form-label"><strong>Age</strong></label>
          <select name="" id="ageSelect" className="form-select" onChange={(e) => setAge(e.target.value)} value={age}>
            <option value="all">All</option>
            <option value="01-17">01-17</option>
            <option value="18-34">18-34</option>
            <option value="35-49">35-49</option>
            <option value="50-59">50-59</option>
            <option value="60-69">60-69</option>
            <option value="70+">70+</option>
          </select>
        </div>
        <div class="filter col-sm-auto">
          <label for="ageSelect" className="form-label"><strong>State</strong></label>
          <select name="" id="ageSelect" className="form-select" onChange={(e) => setState(e.target.value)} value={state}>
            <option value="all">All</option>
            {states.filter(state => state).sort().map(state => <option key={state} value={state}>{state}</option>)}
          </select>
        </div>
        <div className="col-sm-auto">
          <button className="btn btn-outline-dark btn-sm" onClick={reset}>Reset</button>
        </div>
      </div>
      <div class="results" style={{ overflow: 'auto', height: '500px' }}>
        <table className="table table-sm table-striped">
          <thead className="thead-dark">
            <tr>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Rank</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Player</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Gold Points</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Silver Points</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Bronze Points</th>
              <th style={{ position: 'sticky', top: '0', zIndex: '1' }}>Total Points</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default App;
